import type { SxProps, Theme } from '@mui/material/styles';

export const styles = {
    icon: {
        fontSize: 16,
    },
} satisfies Record<string, SxProps<Theme>>;
